import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
import { Link } from 'react-router-dom';
export function AppExperienceSection() {
  const [openIndex, setOpenIndex] = useState(0);
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t,
    direction,
    locale
  } = useLanguage();
  const mobileAppPath = locale === 'ar' ? '/ar/mobile-app' : '/mobile-app';
  const features = [{
    title: t('appExperience.manageAccounts.title'),
    content: t('appExperience.manageAccounts.content')
  }, {
    title: t('appExperience.transactionSummary.title'),
    content: t('appExperience.transactionSummary.content')
  }, {
    title: t('appExperience.accountSummary.title'),
    content: t('appExperience.accountSummary.content')
  }];
  const ArrowIcon = direction === 'rtl' ? ArrowLeftIcon : ArrowRightIcon;
  return <section className="relative py-32 md:py-44 px-6 md:px-12 text-white overflow-hidden min-h-[800px] md:min-h-[750px] lg:min-h-[850px] xl:min-h-[900px] 2xl:min-h-[950px]" dir={direction} data-id="element-115">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-right md:bg-center lg:bg-[center_top]" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/sKosHaycFFsj3ds8QSGL85/BG.jpg')",
      backgroundSize: 'cover'
    }} data-id="element-116"></div>
      {/* Dark overlay for mobile readability */}
      <div className="absolute inset-0 bg-[#061d76]/80 md:bg-transparent" data-id="element-117"></div>

      <div className="max-w-7xl mx-auto relative z-10" ref={ref} data-id="element-118">
        {/* Content - switches sides based on language direction */}
        <div className={`${direction === 'rtl' ? 'ml-0 md:me-auto' : 'ml-0 md:ms-auto'} max-w-xl`} data-id="element-119">
          <h2 className={`text-3xl md:text-4xl font-bold mb-12 reveal-hidden ${isVisible ? 'animate-fade-right' : ''}`} data-id="element-120">
            {t('appExperience.title')}
          </h2>

          <div className="space-y-6 min-h-[280px]" data-id="element-121">
            {features.map((feature, index) => <div key={index} className={`border-b border-white/10 pb-6 cursor-pointer reveal-hidden ${isVisible ? `animate-fade-right delay-${(index + 2) * 100}` : ''}`} onClick={() => setOpenIndex(index === openIndex ? -1 : index)} data-id="element-122">
                <div className="flex items-center justify-between mb-2" data-id="element-123">
                  <h3 className="text-xl font-semibold" data-id="element-124">{feature.title}</h3>
                  {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-cyan-400" data-id="element-125" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400" data-id="element-126" />}
                </div>

                <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-127">
                  <p className="text-white leading-relaxed mt-2" data-id="element-128">
                    {feature.content}
                  </p>
                </div>
              </div>)}
          </div>

          <Link to={mobileAppPath} className={`btn-primary mt-8 reveal-hidden ${isVisible ? 'animate-fade-up delay-600' : ''}`} data-id="element-129">
            {t('appExperience.learnMore')}
            <ArrowIcon className="w-4 h-4" data-id="element-130" />
          </Link>
        </div>
      </div>
    </section>;
}